import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';

const PageLinkWrapper = styled(Link)``;
const ExternalPageLinkWrapper = styled('a')``;
const TextLink = ({ url, blank, children }) => (
  <React.Fragment>
    {blank ? (
      <ExternalPageLinkWrapper href={url} target="_blank">
        {children}
      </ExternalPageLinkWrapper>
    ) : (
      <PageLinkWrapper to={url}>{children}</PageLinkWrapper>
    )}
  </React.Fragment>
);

export default TextLink;
